module.exports = __webpack_public_path__ + "static/hotblack-events3-e9167c96c0e3fbdd1feb3a50a79ee9e7.jpg";